import { DetailedHTMLProps, HTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './block-color.module.css';

export interface BlockColorProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  name: string;
  hex: string;
  rgb: {
    r: number;
    g: number;
    b: number;
  };
  cmyk: {
    c: number;
    m: number;
    y: number;
    k: number;
  };
}

export default function BlockColor({
  className,
  cmyk,
  hex,
  name,
  rgb,
  ...props
}: BlockColorProps) {
  return (
    <div className={cn(className, styles.color)} {...props}>
      <div className={styles.color_start}>
        <div style={{ backgroundColor: hex }} className={styles.color_banner} />
      </div>
      <div className={styles.color_end}>
        <div className={styles.color_title}>{name}</div>
        <div className={styles.color_hex}>{hex}</div>
        <ul className={styles.color_rgb}>
          <li className={styles.color_rgbItem}>{`R ${rgb.r}%`}</li>
          <li className={styles.color_rgbItem}>{`G ${rgb.g}%`}</li>
          <li className={styles.color_rgbItem}>{`B ${rgb.b}%`}</li>
        </ul>
        <ul className={styles.color_cmyk}>
          <li className={styles.color_cmykItem}>{`C ${cmyk.c}%`}</li>
          <li className={styles.color_cmykItem}>{`M ${cmyk.m}%`}</li>
          <li className={styles.color_cmykItem}>{`Y ${cmyk.y}%`}</li>
          <li className={styles.color_cmykItem}>{`K ${cmyk.k}%`}</li>
        </ul>
      </div>
    </div>
  );
}
